import { Toaster } from "components";

import { authenticationConstants } from '../constants';

import { userManagementActions } from '.';

import { promiseInstance, promiseInstance_authorization } from './config';
import { func_validation, func_cookie } from 'functions';



export const authenticationActions = {
	login,
	refreshAccessToken,

	generateEmailOTP,
	resetPassword,

	forceLogout,
	logout,

	getUserInfo,

	toggleLoginModalVisibility,
};

function login(loginInfoObj) {
    return dispatch => {
		dispatch(request());

		promiseInstance().post('/User/Login', loginInfoObj)
			.then(function (details) {
				// handle success
				dispatch(success(details));
			})
			.catch(function (error) {
				// handle error
				dispatch(failure(error));
			})
			.finally(function () {
				// always executed
			});
    }

    function request(details) { return { type: authenticationConstants.login_request, details }; }
    function success(details) { return { type: authenticationConstants.login_success, details }; }
    function failure(error) { return { type: authenticationConstants.login_failure, error }; }
}

function refreshAccessToken(onSuccess, onFailure_validAccessToken) {
    return dispatch => {
		dispatch(request());

		let refresh_token = func_cookie.getCookieValue("refresh_token_bp");
        let tokenInfo = {
            refresh_token: refresh_token,
            grant_type: "refresh_token"
        }

		promiseInstance().post('/User/RefreshToken', tokenInfo)
			.then(function (details) {
				// handle success
				dispatch(success(details));

				if (onSuccess) onSuccess();
			})
			.catch(function (error) {
				// handle error
				dispatch(failure(error));

				if (func_validation.isAccessTokenValid("access_token_bp") && onFailure_validAccessToken) {
					onFailure_validAccessToken();
				}
				else {
					// Refresh token is invalid. Remove it and log out user.
					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Authorization is invalid/expired";
					Toaster({ type: "error", msg });

					dispatch(forceLogout());
				}
			})
			.finally(function () {
				// always executed
			});
    }

    function request(details) { return { type: authenticationConstants.refreshAccessToken_request, details }; }
    function success(details) { return { type: authenticationConstants.refreshAccessToken_success, details }; }
    function failure(error) { return { type: authenticationConstants.refreshAccessToken_failure, error }; }
}

function generateEmailOTP(email) {
    return dispatch => {
		dispatch(request());

		let email_validated = func_validation.isStringTrimNotEmpty(email)? email:"";

		promiseInstance().get('/User/GenerateOtp?email='  + email_validated)
			.then(function (details) {
				// handle success
				dispatch(success(details));
			})
			.catch(function (error) {
				// handle error
				dispatch(failure(error));
			})
			.finally(function () {
				// always executed
			});
    }

    function request(details) { return { type: authenticationConstants.generateEmailOTP_request, details }; }
    function success(details) { return { type: authenticationConstants.generateEmailOTP_success, details }; }
    function failure(error) { return { type: authenticationConstants.generateEmailOTP_failure, error }; }
}

function resetPassword(userInfo) {
    return dispatch => {
		dispatch(request());

		let userInfo_validated = func_validation.isObjectNotEmpty(userInfo)? userInfo:{};
		
		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/User/ChangePassword', userInfo_validated)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully reset password"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to reset password";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: authenticationConstants.resetPassword_request, details }; }
    function success(details) { return { type: authenticationConstants.resetPassword_success, details }; }
    function failure(error) { return { type: authenticationConstants.resetPassword_failure, error }; }
}

function forceLogout() {
    return dispatch => {
		dispatch(request());
		dispatch(success());
    }

    function request(details) { return { type: authenticationConstants.logout_request, details }; }
    function success(details) { return { type: authenticationConstants.logout_success, details }; }
}

function logout() {
    return dispatch => {
		dispatch(request());

		let logoutObj = {
			refresh_token: func_cookie.getCookieValue("refresh_token_bp"),
		}
		
        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/User/LogoutUser', logoutObj)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: authenticationConstants.logout_request, details }; }
    function success(details) { return { type: authenticationConstants.logout_success, details }; }
    function failure(error) { return { type: authenticationConstants.logout_failure, error }; }
}

function getUserInfo() {
    return dispatch => {
		dispatch(request());

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get('/User/LoginInfo')
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: authenticationConstants.getUserInfo_request, details }; }
    function success(details) { return { type: authenticationConstants.getUserInfo_success, details }; }
    function failure(error) { return { type: authenticationConstants.getUserInfo_failure, error }; }
}


function toggleLoginModalVisibility(isModalVisible) {
	return { type: authenticationConstants.loginModalVisiblity, isModalVisible };
}